import React, { useMemo, useRef } from 'react';
import invariant from 'tiny-invariant';

type LayoutRefsContextProps = {
  headerContainerRef: React.RefObject<HTMLDivElement | null>;
  headerAddonsRef: React.RefObject<HTMLDivElement | null>;
  headerCartRef: React.RefObject<HTMLDivElement | null>;
  headerSearchAutocompleteRef: React.RefObject<HTMLDivElement | null>;
  mainBottomRef: React.RefObject<HTMLDivElement | null>;
};

const LayoutRefsContext = React.createContext<
  LayoutRefsContextProps | undefined
>(undefined);

export const LayoutRefsProvider = ({ children }) => {
  const headerContainerRef = useRef<HTMLDivElement>(null);
  const headerAddonsRef = useRef<HTMLDivElement>(null);
  const headerCartRef = useRef<HTMLDivElement>(null);
  const headerSearchAutocompleteRef = useRef<HTMLDivElement>(null);
  const mainBottomRef = useRef<HTMLDivElement>(null);

  const refs = useMemo(
    () => ({
      headerContainerRef,
      headerAddonsRef,
      headerCartRef,
      headerSearchAutocompleteRef,
      mainBottomRef,
    }),
    [headerContainerRef, headerAddonsRef, headerCartRef, mainBottomRef],
  );

  return (
    <LayoutRefsContext.Provider value={refs}>
      {children}
    </LayoutRefsContext.Provider>
  );
};

export const useLayoutRefs = () => {
  const context = React.useContext(LayoutRefsContext);

  invariant(context, 'useLayoutRefs must be used within a LayoutRefsProvider');

  return context;
};
